/** @jsxImportSource @emotion/react */
import { Link } from "basis";

export const Switch = ({ children, onClick }) => {
  const handleClick = (e) => {
    e.preventDefault();
    onClick(e);
  };

  return (
    <Link
      href="#"
      newTab={false}
      css={{ cursor: "pointer" }}
      onClick={handleClick}
    >
      {children}
    </Link>
  );
};
